import { formatString } from "@format-string/core";
import { Box, Chip, Typography } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { CardCore } from "src/Pages/components/CardCore/CardCore";

import { TitleWithValueCore } from "src/Pages/components/TitleWithValueCore/TitleWithValueCore";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";

export const CardProposta = () => {
  const { dataGetByIdContrato } = useContextContrato();

  if (!dataGetByIdContrato) return null;

  const isTypePF = dataGetByIdContrato?.contractType === "PF";

  return (
    <CardCore sxStyle={{ margin: 0 }}>
      <Box
        sx={{
          background: (theme) => theme.custom.gradient.cardSecondary,
          borderRadius: "0 24px 24px 0",
          marginLeft: { xs: "-10px", sm: "-16px" },
          marginBottom: "16px",
          padding: "6px 14px 6px 14px",
          display: "inline-block",
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: "500",
            letterSpacing: "0.04em",
          }}
        >
          {`Proposta: ${dataGetByIdContrato?.proposalCode}`}
        </Typography>
      </Box>
      <Box>
        <Box mb="12px" display={"flex"}>
          <TitleWithValueCore
            isFlex
            sxStyleTitle={{ fontSize: "20px", fontWeight: "500" }}
            sxStyleValue={{ fontSize: "20px", fontWeight: "500" }}
            value={
              dataGetByIdContrato.contractType === "PF"
                ? dataGetByIdContrato.holder
                : dataGetByIdContrato.companyName
            }
          />
          <Chip
            label={
              dataGetByIdContrato.contractType === "PF"
                ? "Pessoa física"
                : "Pessoa jurídica"
            }
            sx={{
              ml: 2,
              border: `1px solid white`,
            }}
          />
        </Box>

        <Box>
          <TitleWithValueCore
            isFlex
            sxStyleTitle={{ fontWeight: "500" }}
            title={isTypePF ? `CPF:` : `CNPJ:`}
            value={
              isTypePF
                ? (formatString({
                    type: "cpf",
                    value: dataGetByIdContrato.cpf,
                  }) as string)
                : (formatString({
                    type: "cnpj",
                    value: dataGetByIdContrato.cnpj,
                  }) as string)
            }
          />
          <TitleWithValueCore
            isFlex
            sxStyleTitle={{ fontWeight: "500" }}
            title="Email:"
            value={dataGetByIdContrato.ContractContact.email}
          />
          <TitleWithValueCore
            isFlex
            sxStyleTitle={{ fontWeight: "500" }}
            title="Telefone(s):"
            value={
              dataGetByIdContrato.ContractContact.phone1 ||
              dataGetByIdContrato.ContractContact.phone2
                ? `${cpfOurCnpj({
                    text: dataGetByIdContrato.ContractContact.phone1,
                    type: "phone",
                  })} / ${
                    (dataGetByIdContrato.ContractContact.phone2 &&
                      cpfOurCnpj({
                        text: dataGetByIdContrato.ContractContact.phone2,
                        type: "phone",
                      })) ||
                    "' '"
                  }`
                : "' '"
            }
          />
        </Box>
      </Box>
    </CardCore>
  );
};
